/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { GetUploadQueryResponse, GetUploadPathParams } from "../models/GetUpload";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getUpload } from "../axios/getUpload";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getUploadQueryKey = (id: GetUploadPathParams["id"]) => ["social-export-api", { url: '/upload/:id', params: {id:id} }] as const

export type GetUploadQueryKey = ReturnType<typeof getUploadQueryKey>

export function getUploadQueryOptions(id: GetUploadPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getUploadQueryKey(id)
        return queryOptions<GetUploadQueryResponse, ResponseErrorConfig<Error>, GetUploadQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getUpload(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get upload by ID
 * {@link /upload/:id}
 */
export function useGetUpload<TData = GetUploadQueryResponse, TQueryData = GetUploadQueryResponse, TQueryKey extends QueryKey = GetUploadQueryKey>(id: GetUploadPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<GetUploadQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getUploadQueryKey(id)
         

         const query = useQuery({
          ...getUploadQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}